import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Navitems } from '../topheader/Models/navitems.model';
import { filter } from 'rxjs/operators';
import { CommonService } from "../../services/common/common.service";
import { UserRoleType } from 'src/app/enums/user-role-type.enum';
import { MsalService } from '@azure/msal-angular';
import { AdminRequestService } from 'src/app/services/admin-request/admin-request.service';
import { UpdateComponentService } from '../updateComponent.module';
import { SidebarService } from '../../services/sidebar/sidebar.service';
@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})

export class SidebarComponent implements OnInit {
  url: string;
  sideNavItems: Navitems[];
  location='';
  isRequestPage=false;
  showTabFeatureFlag:any;
  isBulkApprover=false;
  isBulkGbser=false;
  isBulkUploader=false;
  client:any;
  permissions: {
    adminPermissions: boolean,
    GBSBillingPermissions: boolean,
    BulkRequestPermissions: boolean,
    RaiseRequestPermissions: boolean,
    ViewReportsPermissions: boolean,
    ApprovalDashboardPermissions: boolean
    BulkRequestApprovalPermissions:boolean
    BulkRequestGbsPermissions:boolean
  } = {
    adminPermissions: false,
    GBSBillingPermissions: false,
    BulkRequestPermissions: false,
    RaiseRequestPermissions: false,
    ViewReportsPermissions: false,
    ApprovalDashboardPermissions: false,
    BulkRequestApprovalPermissions:false,
    BulkRequestGbsPermissions:false,
  }
  RoleIds: number[] = [];
  result:any;
  refreshSidebar: boolean = false;

  constructor(private router: Router,  private msalService: MsalService,
    private commonService: CommonService,  private adminRequestService: AdminRequestService,
    private updateComponentService: UpdateComponentService,private sideBarService: SidebarService
  ) {
    this.url = window.location.href;
    router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.location = event.urlAfterRedirects;

      if(this.location =="/requests/new" || this.location == "/approval/approval-dashboard" ||  this.location == "/gbs/gbs-dashboard"|| this.location == "/gbs/gbs-history" || this.location == "/gbs/gbs-process-request" ||   this.location =="/requests/history" || this.location == "/approval/approval-history" || this.location == "/request-status-reports" ||  this.location =="/admin-request" || this.location == "/bulk-request" || this.location=="/bulk-request-history" || this.location=="/bulk-request-approvaldashboard"|| this.location=="/bulk-request-approvalhistory"|| this.location=="/bulk-request-gbshistory"||this.location=="/bulk-request-gbspending" || this.location =="/requests/prs-request"|| this.location=="/bulk-request-reports"){

         this.isRequestPage=true;
      }else{
        this.isRequestPage=false;
      }
    });
      this.updateComponentService.getUpdate().subscribe
      (message => { 
      this.permissions = message;
      });

      this.sideBarService.refreshSidebar.subscribe( value => {
        this.refreshSidebar = value;
        if(this.refreshSidebar){
          this.getFeatureFlagValue();
          this.checkUserIsAuthenticated();
        }        
    });
  }

  ngOnInit() {
    this.url = window.location.href;
    this.getFeatureFlagValue();
    this.checkUserIsAuthenticated();
  }

   getFeatureFlagValue() {
      this.commonService.getFeatureFlagByName('showTab').subscribe(
        (response) => {
          this.showTabFeatureFlag = response.isEnabled;
        }
      );
  }

  onGoToReports(): void {
    
    localStorage.removeItem("topMenu");
    localStorage.setItem("topMenu", "reports"); 
  }
  onGoToApps(): void {

    localStorage.removeItem("topMenu");
    localStorage.setItem("topMenu", "applications");
  }
  onGoToOtherMenu(): void {
    localStorage.removeItem("topMenu");
    localStorage.setItem("topMenu", "otherMenus");
  }
  // expandSideBar(event): void {
  //   document.querySelector('.sidebar').classList.toggle('opened');
  //   document.querySelector('body').classList.toggle('sidebar-opened');
  // }

   
    checkUserIsAuthenticated() 
    {
      var jsonData = {
        CloudId:  this.msalService.instance.getActiveAccount().username.toString()
       };
       this.result = this.adminRequestService.userRoles(jsonData).subscribe((result) => {
        this.RoleIds = [];
        var roleResponse = result;
        roleResponse.forEach(element => {
         this.RoleIds.push(element.roleId);
        });

        if(this.RoleIds.includes(UserRoleType.Admin)){
          this.permissions.adminPermissions = true;
        }
        else{
          this.permissions.adminPermissions = false;
        }

        if(this.RoleIds.includes(UserRoleType.AE_User) || this.RoleIds.includes(UserRoleType.RPF_Billers) || this.RoleIds.includes(UserRoleType.Operations_Manager)
          || this.RoleIds.includes(UserRoleType.Sales_Support) || this.RoleIds.includes(UserRoleType.Finance_User) || this.RoleIds.includes(UserRoleType.Pricing) || this.RoleIds.includes(UserRoleType.Finance_Manager))
        {
          this.permissions.RaiseRequestPermissions = true;
          this.isBulkUploader=true;
        }else{
          this.permissions.RaiseRequestPermissions = false;
          this.isBulkUploader=false;
        }

        if( this.RoleIds.includes(UserRoleType.Finance_Director) || this.RoleIds.includes(UserRoleType.Finance_Manager))
        {
          this.permissions.ApprovalDashboardPermissions= true
          this.isBulkApprover=true;
        }else{
          this.permissions.ApprovalDashboardPermissions= false
          this.isBulkApprover=false;
        }

        if(this.RoleIds.includes(UserRoleType.Operations_Manager) || this.RoleIds.includes(UserRoleType.Operations_Regional_Manager))
          {
            this.permissions.ApprovalDashboardPermissions= true
            // this.isBulkApprover= this.isBulkApprover || false;
            this.isBulkUploader= this.isBulkUploader || true;
          }else{
            this.permissions.ApprovalDashboardPermissions= false
            // this.isBulkApprover=this.isBulkApprover ||false;
            this.isBulkUploader= this.isBulkUploader || false;
          }

        if(this.RoleIds.includes(UserRoleType.GBS_Billing) || this.RoleIds.includes(UserRoleType.GBS_Collection)|| this.RoleIds.includes(UserRoleType.District_Manager))
        {         
          this.permissions.GBSBillingPermissions= true
          this.permissions.BulkRequestGbsPermissions=true
          this.isBulkGbser=true;
        }else{
          this.permissions.GBSBillingPermissions= false
          this.permissions.BulkRequestGbsPermissions=false
          this.isBulkGbser=false;
        }
      }) 
        }
}
